import React from "react";
import { Alert, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function TeacherNavigationUnavailable() {
  return (
    <Container className="py-5">
      <Alert variant="info" className="text-center">
        <Alert.Heading>This area is currently unavailable.</Alert.Heading>
        <p>Please return to Home to continue using the Teacher Dashboard.</p>
        <Button as={Link} to="/masterdashboard" variant="primary">
          Return to Home
        </Button>
      </Alert>
    </Container>
  );
}

export default TeacherNavigationUnavailable;
